"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _containers = require("../containers");
var _components = require("../components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NewPasswordView = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow p-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "card-title"
  }, "Please create your own password"), /*#__PURE__*/_react.default.createElement(_containers.NewPassword, props, /*#__PURE__*/_react.default.createElement(_components.NewPasswordForm, null))))));
};
var _default = exports.default = NewPasswordView;
module.exports = exports.default;